import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { BUILD_STAMP } from "@/buildInfo";

// --- Defensive: unregister any ServiceWorker from a previous version of this
// SPA. If a SW was ever registered on this origin, browsers will keep serving
// the (stale) cached app forever, which can manifest as ghost "not
// authenticated" errors after a fix.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => {
      registrations.forEach((reg) => {
        // eslint-disable-next-line no-console
        console.warn("Unregistering stale service worker:", reg.scope);
        reg.unregister().catch(() => {});
      });
    })
    .catch(() => {});
  // Also nuke any caches the SW may have left behind.
  if (typeof caches !== "undefined") {
    caches.keys().then((keys) => keys.forEach((k) => caches.delete(k))).catch(() => {});
  }
}

// Stamp the document with the build version so a hard-reload + view source
// makes it obvious which bundle is loaded.
try {
  const meta = document.createElement("meta");
  meta.name = "x-app-build";
  meta.content = BUILD_STAMP;
  document.head.appendChild(meta);
  // eslint-disable-next-line no-console
  console.info("[shared-chat] build", BUILD_STAMP);
} catch (_) {
  /* noop */
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
